import * as IMG from '@Utils/Images';

export default function Component() {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-5 pe-0 order-lg-1 order-2">
            <div className="subtitle">Perfect Clothing Store</div>
            <h1 className="fw-bolder lh-base title">
              The Best Place To Find And Buy <span>Amazing</span> Brand New
              <span>Clothes</span>
            </h1>
            <div className="d-flex align-items-center mt-4 mb-5">
              <div className="description-border"></div>
              <p className="description fw-medium text-secondary m-0 ms-3">
                Fashion is part of the daily air and it changes all of time,
                with all the events. We only sell the best and serve you
                comfortably
              </p>
            </div>
            <div className="d-sm-flex align-items-center">
              <button className="btn btn-dark text-white fw-semibold rounded-0 py-3 px-sm-4 px-5 me-sm-5">
                Start Shopping
                <span className="ms-2 text-primary2">
                  <i className="fa-solid fa-chevron-right"></i>
                </span>
              </button>
              <a
                href="/"
                className="d-flex align-items-center flex-wrap text-primary2 mt-sm-0 mt-4"
              >
                <h3 className="me-3 m-0">
                  <i className="fa-solid fa-circle-play"></i>
                </h3>
                <p className="fw-bold m-0">Explore More</p>
              </a>
            </div>
          </div>
          <div className="col-lg-7 p-0 ps-lg-5 order-lg-2 order-1 mb-lg-0 mb-5">
            <img
              src={IMG.HERO}
              alt="hero"
              width="100%"
            />
          </div>
        </div>
      </div>
    </section>
  );
};